import { StylingModel } from '../style/styling.model';
import { CoreStylingModel } from '../core/core-styling.model';
import { ButtonStylingModel } from '../button/button-styling.model';
import { ToolbarStylingModel } from '../toolbar/toolbar-styling.model';
export class DialogStylingModel extends CoreStylingModel {
/**
 * Styling for the dialog header.
 */
header?: {
    /**
         * Classes for header section.
         */
    class?: string;
    /**
     * Dynamic classes for header section.
     */
    dynamicClass?: any;
    /**
         * ToolbarStylingModel for the header toolbar.
         */
    toolbar?: ToolbarStylingModel;
  };
/**
 * Styling for the dialog content section with message and template inside.
 */
content?: {
    /**
         * Classes for content section.
         */
    class?: string;
    /**
     * Dynamic classes for content section.
     */
    dynamicClass?: any;
    /**
         * StylingModel for the dialog content message.
         */
    message?: StylingModel;
    /**
         * StylingModel for the dialog content template.
         */
    template?: StylingModel;
  };
/**
 * Styling for the dialog footer.
 */
footer?: {
    /**
         * Classes for footer section.
         */
    class?: string;
    /**
     * Dynamic classes for footer section.
     */
    dynamicClass?: any;
    /**
         * ButtonStylingModel for the dialog okButton.
         */
    okButton?: ButtonStylingModel;
    /**
         * ButtonStylingModel for the dialog cancelButton.
         */
    cancelButton?: ButtonStylingModel;
    /**
         * StylingModel for the dialog template.
         */
    template?: StylingModel;
  };
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function DialogStylingModel_tsickle_Closure_declarations() {
/**
 * Styling for the dialog header.
 * @type {?}
 */
DialogStylingModel.prototype.header;
/**
 * Styling for the dialog content section with message and template inside.
 * @type {?}
 */
DialogStylingModel.prototype.content;
/**
 * Styling for the dialog footer.
 * @type {?}
 */
DialogStylingModel.prototype.footer;
}

